module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.appType === _vm.constants.APP_TYPE_DEFAULT || (_vm.appType === _vm.constants.APP_TYPE_MULTIPLE && _vm.localCoregs.length)) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localCoregs.length > _vm.hiddenCoregs.length),
      expression: "localCoregs.length > hiddenCoregs.length"
    }],
    staticClass: "vanguard-coreg-container"
  }, _vm._l((_vm.visibleCoregs), function(coreg, index) {
    return _c('div', {
      key: 'coreg-' + index,
      staticClass: "form-group form-check"
    }, [_c('label', {
      staticClass: "form-check-label"
    }, [_c('input', {
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": coreg.checked,
        "checked": coreg.checked
      },
      on: {
        "change": function($event) {
          return _vm.updateModel(coreg, $event.target.checked)
        }
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(coreg.label)
      }
    })])])
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c75fcde","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/coregs.vue
// module id = 868
// module chunks = 0 1